/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class s{constructor(s,t=null){this.screenPoint=s,this.result=t}}class t{constructor(s,t){this.scenePoint=s,this.mapPoint=t}}export{s as PickRequest,t as PickResult};
